// syncService.js
import indexedDbStorage from "../store/indexedDbStorage.js";

import { setFoods } from "../store/foodsSlice";
import { setMeals } from "../store/mealsSlice";
import { setPersonalAll } from "../store/personalSlice";
import { setToday, clearToday } from "../store/todaySlice";

let lastSyncHash = null;
let syncTimer = null;
let isRehydrated = false; // ✅ guard

export function markRehydrated() {
  isRehydrated = true;
}

export const buildSnapshot = (state) => {
  return {
    foods: state.foods?.byId ? Object.values(state.foods.byId) : [],
    meals: state.meals?.byId ? Object.values(state.meals.byId) : [],
    entries: state.today?.entries || [],
    profile: state.personal?.profile || {},
    byDate: state.personal?.byDate || {},
  };
};

// ✅ NEW — called from store.subscribe
export function scheduleIDBWrite(store) {
  if (!isRehydrated) return;

  clearTimeout(syncTimer);
  syncTimer = setTimeout(async () => {
    const snapshot = buildSnapshot(store.getState());
    await indexedDbStorage.saveSnapshot(snapshot);
  }, 500);
}

export function markUnrehydrated() {
  isRehydrated = false;
  clearTimeout(syncTimer); // ✅ kill any pending debounced write
  syncTimer = null;
}

export async function syncNow(store) {
  if (!isRehydrated) return; // ✅ guard

  const token = localStorage.getItem("token");
  if (!token) return;

  const state = store.getState();
  const snapshot = buildSnapshot(state);
  const currentSyncHash = JSON.stringify(snapshot);
  

  if (currentSyncHash === lastSyncHash) return;

  try {
    // const currentDate = state.today?.date || new Date().toISOString().split("T")[0];
    const currentDate = state.today?.date || new Date().toLocaleDateString('en-CA', {
      timeZone: 'Europe/Berlin'
    });

    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/sync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ date: currentDate, data: snapshot }),
    });

    // if (res.ok) {
    //   lastSyncHash = currentSyncHash;
    //   await indexedDbStorage.saveSnapshot(snapshot); // ✅ mirror to IDB on successful sync
    //   console.log("✅ Sync successful: Data saved.");
    // }
    if (res.ok) {
      lastSyncHash = currentSyncHash;
      if (isRehydrated) await indexedDbStorage.saveSnapshot(snapshot); // ✅
      console.log("✅ Sync successful: Data saved.");
    }
  } catch (err) {
    console.error("Sync failed", err);
  }
}

export async function fetchAndRehydrate(store) {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const today = new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' });
    const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('en-CA', { timeZone: 'Europe/Berlin' });

    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/sync?date=${today}&prevDate=${yesterday}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (!res.ok) throw new Error("Fetch failed");

    const { snapshot, actualDate } = await res.json();
    if (!snapshot) return;

    const { dispatch } = store;

    if (snapshot.foods) dispatch(setFoods(snapshot.foods));
    if (snapshot.meals) dispatch(setMeals(snapshot.meals));
    if (snapshot.profile) dispatch(setPersonalAll({
      profile: snapshot.profile,
      byDate: actualDate === today ? (snapshot.byDate || {}) : {},
    }));

    // setToday now filters by German time internally ✅
    if (snapshot.entries) {
      dispatch(setToday(snapshot.entries));
    } else {
      dispatch(clearToday());
    }

    await indexedDbStorage.saveSnapshot(snapshot);
    console.log("✅ Manual refresh complete");
  } catch (err) {
    console.error("Manual refresh failed", err);
  }
}

export async function fetchHistory() {
  const token = localStorage.getItem("token");
  if (!token) return [];

  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/sync/history`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error("History fetch failed");
    const { history } = await res.json();

    return history.map(({ date, snapshot }) => {
      const entries = snapshot?.entries ?? [];
      const foods = snapshot?.foods ?? [];
      const foodsById = Object.fromEntries(foods.map(f => [f.id, f]));

      const calories = entries.reduce((sum, entry) => {
        return sum + Object.entries(entry.portions ?? {}).reduce((s, [foodId, grams]) => {
          const food = foodsById[foodId];
          return food ? s + (food.calories / 100) * grams : s;
        }, 0);
      }, 0);

      return { date, calories: Math.round(calories) };
    });
  } catch (err) {
    console.error("History fetch failed", err);
    return [];
  }
}

// export async function fetchAllSnapshots() {
//   const token = localStorage.getItem("token");
//   if (!token) return [];

//   try {
    
//     const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/sync/history`, {
//       headers: { Authorization: `Bearer ${token}` },
//     });
//     if (!res.ok) throw new Error("History fetch failed");
//     const { snapshots } = await res.json();
//     return snapshots; // [{ date, data: { entries, ... } }, ...]
//   } catch (err) {
//     console.error("History fetch failed", err);
//     return [];
//   }
// }

// export async function fetchAndRehydrate(store) {
//   const token = localStorage.getItem("token");
//   if (!token) return;

//   try {
//     const todayStr = new Date().toISOString().split("T")[0];
//     const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/sync?date=${todayStr}`, {
//       headers: { Authorization: `Bearer ${token}` },
//     });

//     if (!res.ok) throw new Error("Fetch failed");

//     const { snapshot, actualDate } = await res.json();
//     console.log("🔄 refresh snapshot:", snapshot); // ← confirm data arrives
//     if (!snapshot) return;

//     const { dispatch } = store;

//     if (snapshot.foods) dispatch(setFoods(snapshot.foods));
//     if (snapshot.meals) dispatch(setMeals(snapshot.meals));
//     if (snapshot.profile) dispatch(setPersonalAll({
//       profile: snapshot.profile,
//       byDate: actualDate === todayStr ? (snapshot.byDate || {}) : {},
//     }));

//     if (actualDate === todayStr && snapshot.entries) {
//       dispatch(setToday(snapshot.entries));
//     } else {
//       dispatch(clearToday());
//     }

//     await indexedDbStorage.saveSnapshot(snapshot);
//     console.log("✅ Manual refresh complete");
//   } catch (err) {
//     console.error("Manual refresh failed", err);
//   }
// }